import angular, { forEach, ILogService, IOnChangesObject, ITimeoutService } from 'angular'
import { AsyncFilter, FileItem, FileUploader, FileUploaderFactory, SyncFilter } from 'angular-file-upload'
import { BASE_CANDIDATO_API } from 'src/_candidato/comun/services/acceso-datos'
import { CVModel, T_RespModel } from 'src/_candidato/data/cv/CVModel'
import { CVResp } from 'src/_candidato/data/cv/CVResp'
import { $candidatoPublicMod } from 'src/_candidato/public/candidato-public-mod'
import { IICuestionarioPreg, IModelRespuesta } from 'src/model/candidato-api'
import './editcv-preg.component'
import { Datepicker } from 'materialize-css'
import moment from 'moment'
import { flatMap, groupBy, sortBy, values } from 'lodash'

class EditcvPregComponentCtrl {
  q!: IICuestionarioPreg
  superq!: IICuestionarioPreg
  cvmodel!: CVModel
  idx!: number // índice dentro de una row
  params!: { [v: string]: any }
  principal!: boolean

  rows: string[] = []
  others: string[] = []

  cvresp: CVResp
  respmodel: T_RespModel = {
    opt: null,
    opts: null,
    others: null,
    t: null,
    f: null,
    val: null,
    n: null,
    d: null,
    yesno: {
      yes: false,
      no: false,
      details: null,
    },
    valid: true,
  }

  uploader: FileUploader
  uploadReady = false

  inline: boolean
  mostrar: boolean

  _datepicker: M.Datepicker | null
  _date: Date | null

  constructor(
    private $element: JQLite,
    private $timeout: ITimeoutService,
    private $log: ILogService,
    private FileUploader: FileUploaderFactory
  ) {}

  $onInit(): void {
    this.$log.info('[EditcvPregComponentCtrl] onInit')

    // si es de tipo row, una fila por lo menos
    if (this.q.tq == 'ROW' || this.q.tq == 'FILE') {
      this.rows.push('')
    }

    this.cvresp = this.cvmodel.nuevaPreg(this.q, this.superq, this.respmodel, this.idx, this.params)

    this.inline =
      this.q.tq == 'TEXT' ||
      this.q.tq == 'DATE' ||
      this.q.tq == 'NUMBER' ||
      this.q.tq == 'SELECT' ||
      this.q.tq == 'EMAIL' ||
      this.q.tq == 'YESNO'

    this.mostrar = this.q.tq != 'PARAM' && this.q.tq != 'PARAMOCULTO'

    // si hay respuesta original...
    if (this.cvresp.respOriginal?.respuestas.length) {
      this._modeloOriginal(this.cvresp.respOriginal.respuestas)
    }
  }

  $onChanges(object: IOnChangesObject) {
    // actualizar el idx si cambia
    if (object.idx && angular.isDefined(object.idx.currentValue) && object.idx.currentValue != null && this.cvresp) {
      this.$log.debug('Nuevo idx', object.idx)
      this.cvresp.idx = object.idx.currentValue
    }
  }

  $postLink() {
    let m = moment('01/01/1940', 'dd/mm/YYYY')
    let max = moment().add(10, 'y')

    this.$timeout(() => {
      ;(this.$element.find('select') as any).formSelect()
      ;(this.$element.find('.datepicker') as any).datepicker({ autoClose: true })
      //
      var instances = M.Datepicker.init(this.$element.find('.datepicker') as any, {
        autoClose: true,
        minDate: m.toDate(),
        maxDate: max.toDate(),
        yearRange: [1950, max.year()],
        firstDay: 1,
        // container: document.body,
        // onOpen: function () {
        //   angular.element(document.body).addClass('datepicker-open')
        // },
        // onClose: function () {
        //   angular.element(document.body).removeClass('datepicker-open')
        // },
        // onSelect: function () {
        //   angular.element(document.body).removeClass('datepicker-open')
        // },
      }) as unknown as Datepicker[]

      if (instances.length) {
        this._datepicker = instances[0]

        if (this._date) {
          console.log('----> moment ', moment(this._date).format('MMM DD, yyyy'))
          this._datepicker.setDate(moment(this._date).format('MMM DD, yyyy'))
        }
      }

      console.log('datepicker ==> ', instances, this.$element.find('.datepicker'))
    }, 500)

    this.$timeout(() => {
      let textarea = this.$element.find('.materialize-textarea')

      if (textarea && textarea[0]) {
        console.log('------> textareaAutoResize')
        M.textareaAutoResize(textarea)
      }
    }, 10)

    if (this.q.tq == 'FILE')
      this.$timeout(() => {
        this.initFileUploads()
      }, 100)
  }

  private _modeloOriginal(rlist: IModelRespuesta[]) {
    // si es de tipo múltiple, cada respuesta es una opción
    if (this.q.tq === 'MULTIPLE') {
      this._modeloRespMultiple(rlist)
    } else if (this.q.tq === 'ROW') {
      this._modeloRespRow(rlist)
    } else {
      // elegir la primera
      this._modeloRespOriginal(rlist[0])
    }
  }

  private _modeloRespOriginal(r: IModelRespuesta) {
    switch (this.q.tq) {
      case 'TEXT':
      case 'MEMO':
      case 'EMAIL':
      case 'PARAM':
      case 'PARAM2':
      case 'PARAMOCULTO':
        this.respmodel.t = r.resp_txt
        break

      case 'DATE':
        if (r.resp_fec) {
          this._date = new Date(r.resp_fec)
          this.respmodel.d = moment(this._date).format('MMM DD, yyyy') as unknown as Date
        }
        break

      case 'NUMBER':
        this.respmodel.n = r.resp_num
        break

      case 'SELECT':
        this.respmodel.opt = r.resp_opt
        break

      case 'YESNO':
        this.respmodel.yesno.no = !(this.respmodel.yesno.yes = r.resp_bool)
        if (this.respmodel.yesno.yes) {
          this.respmodel.yesno.details = r.resp_yndet
        }
        break

      case 'ERROR':
      default:
    }
  }

  private _modeloRespMultiple(rr: IModelRespuesta[]) {
    // inicializa
    this.respmodel.opts = new Array(this.q.opts.length)

    // opción -> respuesta[]
    const marcadas = groupBy(rr, (r) => r.resp_opt)

    // cada grupo, ordenado por idx

    // cada respuesta es una opción seleccionada
    // para todas las opciones de la pregunta, marcar si está seleccionada
    this.q.opts.forEach((opt, idx) => {
      const marcadas_opt = marcadas[opt]

      if (marcadas_opt?.length) {
        const marcada = marcadas_opt.shift()

        this.respmodel.opts[idx] = {
          opt,
          obvs: this.q.includeDetails ? marcada.resp_obvs : null,
        }
      }
    })

    // las que quedan son others
    this.respmodel.others = []
    const others = flatMap(values(marcadas).filter((opts) => opts.length))

    if (others.length) {
      this.others = new Array(others.length)
    }

    // ordenadas por idx
    sortBy(others, (r) => r.optidx).forEach((other) => {
      this.respmodel.others.push({
        opt: other.resp_opt,
        obvs: this.q.includeDetails ? other.resp_obvs : null,
      })
    })
  }

  private _modeloRespRow(rr: IModelRespuesta[]) {
    // el nº de respuestas es el nº de filas
    this.rows = new Array(rr.length)
  }

  moreinfo() {
    this.rows.push('')
  }

  addOther() {
    this.others.push('')
  }

  yesnochange(prop: 'yes' | 'no') {
    let val = this.respmodel.yesno[prop]

    if (val) this.respmodel.yesno[prop == 'yes' ? 'no' : 'yes'] = false
  }

  private initFileUploads() {
    let uploader = (this.uploader = new this.FileUploader({
      // url: BASE_CANDIDATO_API + "api/_cv/n/abc/f"
      //,timeout: 2000
    }))

    this.uploadReady = true

    // uploader.url = BASE_CANDIDATO_API + "api/_cv/n/abc/f"

    // FILTERS

    // a sync filter
    uploader.filters.push({
      name: 'syncFilter',
      fn: function (item /*{File|FileLikeObject}*/, options) {
        console.log('syncFilter')
        return this.queue.length < 10
      } as SyncFilter,
    })

    // an async filter
    uploader.filters.push({
      name: 'asyncFilter',
      fn: function (item /*{File|FileLikeObject}*/, options, deferred) {
        console.log('asyncFilter')
        setTimeout(deferred.resolve, 1e3)
      } as AsyncFilter,
    })

    // CALLBACKS

    uploader.onWhenAddingFileFailed = function (item /*{File|FileLikeObject}*/, filter, options) {
      console.info('onWhenAddingFileFailed', item, filter, options)
    }
    uploader.onAfterAddingFile = function (fileItem) {
      if (uploader.queue.length > 1) {
        uploader.removeFromQueue(0)
      }

      console.info('onAfterAddingFile', fileItem)
      console.info('onAfterAddingFile', uploader.queue)
    }
    uploader.onAfterAddingAll = function (addedFileItems) {
      console.info('onAfterAddingAll', addedFileItems)
    }
    uploader.onBeforeUploadItem = function (item: FileItem) {
      console.info('onBeforeUploadItem', item)

      var f = new FormData()

      f.append('foo', '2')

      item.formData.push(f)
    }
    uploader.onProgressItem = function (fileItem, progress) {
      console.info('onProgressItem', fileItem, progress)
    }
    uploader.onProgressAll = function (progress) {
      console.info('onProgressAll', progress)
    }
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      console.info('onSuccessItem', fileItem, response, status, headers)
    }
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      console.info('onErrorItem', fileItem, response, status, headers)
    }
    uploader.onCancelItem = function (fileItem, response, status, headers) {
      console.info('onCancelItem', fileItem, response, status, headers)
    }
    uploader.onCompleteItem = function (fileItem, response, status, headers) {
      console.info('onCompleteItem', fileItem, response, status, headers)
    }

    uploader.onCompleteAll = function () {
      console.info('onCompleteAll')
    }

    console.info('uploader', uploader)

    this.cvresp.uploaderFiles(uploader)
  }

  testUpload() {
    let _up = this.uploader

    this.$log.debug('test uploader', _up.queue)

    _up.url = BASE_CANDIDATO_API + 'api/_cv/n/abc/f'

    let idx = 0
    _up.queue.forEach((f) => {
      f.onComplete = (response, status, headers) => {
        this.$log.debug('Complete!!!!!', status)
      }

      var fd = new FormData()

      fd.append('idx', '' + idx++)

      f.formData = [fd]

      f.url = BASE_CANDIDATO_API + 'api/_cv/n/abc/f'

      _up.uploadItem(f)
    })
  }
}

$candidatoPublicMod.component('editcvPreg', {
  bindings: {
    q: '<',
    superq: '<',
    cvmodel: '<',
    params: '<',
    idx: '<',
    principal: '<',
    verestruct: '<',
    verrespuestas: '<',
  },
  controller: EditcvPregComponentCtrl,
  template: require('./editcv-preg.component.html'),
  //templateUrl: "./editcv-preg.component.html"
})

// inicializar el fileupload de cabecera
